"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var OrdersView_1 = require("views/OrdersView");
var OrderWizardView_1 = require("views/OrderWizardView");
var translate_1 = require("utils/translate");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
function getMode(value) {
    if (value === void 0) { value = ''; }
    switch (value.toUpperCase()) {
        case 'CREATE':
            return 'CREATE';
        case 'EDIT':
            return 'EDIT';
        default:
            return 'VIEW';
    }
}
exports.default = (0, recompose_1.pure)(function (props) {
    var baseUrl = props.match.path;
    var currentFolder = props.currentFolder, currentProject = props.currentProject, metadata = props.metadata;
    if (!(currentProject.perm & acl.ORDER_PERM)) {
        return (React.createElement(react_router_dom_1.Redirect, { key: 'redirect', to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(currentProject.id) }));
    }
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { exact: true, key: 'list-view', path: baseUrl + "/", render: function (props) { return (React.createElement(OrdersView_1.default, __assign({}, props, { currentProject: currentProject, currentFolder: currentFolder }))); } }),
        React.createElement(react_router_dom_1.Route, { exact: true, key: 'edit-view', path: baseUrl + "/:mode/:id?", render: function (props) { return (React.createElement(OrderWizardView_1.OrderWizardView, __assign({}, props, { type: 'SINGLE', mode: getMode(props.match.params.mode), currentProject: currentProject, currentFolder: currentFolder, metadata: metadata }))); } })));
});
